export default __webpack_public_path__ + "static/media/home-dentist-icon-02.03704d22.svg";